import React from 'react';

import Loading from '../../Loading';
import useScatterData from './useScatterData';
import ScatterView from './ScatterView';

const ScatterContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, isReady } = useScatterData({
    chartDefinition,
    chartRef,
  });

  if (!isReady) {
    return <Loading />;
  }

  return (
    <ScatterView
      chartRef={chartRef}
      options={options ?? {}}
      isNoData={isNoData || !options}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default ScatterContent;
